import { Component, HostBinding, Input } from '@angular/core';

import { AppNavigationItem } from '@amplabs/types';

@Component({
    selector   : 'fuse-nav-vertical-group',
    templateUrl: './group.component.html',
    styleUrls  : ['./group.component.scss']
})
export class AppNavVerticalGroupComponent
{
    @HostBinding('class')
    classes = 'nav-group nav-item';

    @Input()
    item: AppNavigationItem;

    @Input()
    hidden: boolean;

    /**
     * Constructor
     */
    constructor()
    {
    }

}
